export default __webpack_public_path__ + "static/media/MYCV.4458f613.pdf";